import { Component, HostBinding, Inject, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavContainer, MatSidenavContent, } from '@angular/material/sidenav';
import { MatListItem, MatNavList } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { HeaderSectionComponent } from '../header-section/header-section.component';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FooterComponent } from '../reusable-components/footer/footer.component';
import { MediaInputService } from '../services/media-input/media-input.service';
import { MatToolbar } from '@angular/material/toolbar';
import { LoginService } from "../login/login.service";
import { ENVIRONMENT } from '../../environments/environment.token';
import { EnvironmentInterface } from '../../environments/environment.interface';

@Component({
  selector: 'app-side-nav',
  imports: [
    MatSidenav,
    MatNavList,
    MatSidenavContainer,
    MatSidenavContent,
    MatListItem,
    MatIcon,
    MatIconButton,
    HeaderSectionComponent,
    TranslatePipe,
    FooterComponent,
    MatToolbar,
  ],
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss',
})
export class SideNavComponent {
  @ViewChild('sidenav') sidenav: MatSidenavContainer | undefined;

  @HostBinding('class') get hostClass(): string {
    return `stage-${this.environment.stage}`;
  }

  constructor(
    private readonly router: Router,
    private readonly mediaInputService: MediaInputService,
    private readonly loginService: LoginService,
    @Inject(ENVIRONMENT) private readonly environment: EnvironmentInterface,
  ) {
  }

  get isAdmin() {
    return this.loginService.isAdmin;
  }

  goToLeadPool() {
    this.sidenav?.close();
    this.router.navigateByUrl('/lead-pool');
  }

  changeMediaSettings() {
    this.mediaInputService.resetMediaConfiguration();
    this.sidenav?.close();
    this.router.navigateByUrl('/media-input', { state: { manual: true } });
  }

  changeRouteSettings() {
    this.sidenav?.close();
    this.router.navigateByUrl('/route-settings');
  }

  goToParquetImport() {
    this.sidenav?.close();
    this.router.navigateByUrl('/parquet-import');
  }

  goToAdminPanel() {
    this.sidenav?.close();
    this.router.navigateByUrl('/admin-panel');
  }
}
